import dagre from "dagre";
import _ from "lodash";

export const createGraphLayout = (nodes, edges) => {
  const g = new dagre.graphlib.Graph();
  g.setGraph({ rankdir: "TB", ranksep: 150, nodesep: 20 });
  g.setDefaultEdgeLabel(() => ({}));

  nodes.forEach((node) => {
    g.setNode(node.id, {
      width: node.width,
      height: node.height,
    });
  });

  edges.forEach((edge) => {
    g.setEdge(edge.source, edge.target);
  });

  dagre.layout(g);

  // change node datam for react flow
  nodes.forEach((node) => {
    const nodeWithPosition = g.node(node.id);
    node.targetPosition = "top";
    node.sourcePosition = "bottom";

    node.position = {
      x: nodeWithPosition.x - node.width / 2,
      y: nodeWithPosition.y - node.height / 2,
    };

    return node;
  });

  // early return if only one node exists
  if (nodes.length === 1) {
    return { layoutedNodes: nodes, layoutedEdges: edges };
  }

  // align nodes to top of rank
  const groupedNodes = _.groupBy(nodes, ({ type }) => type);
  Object.keys(groupedNodes).forEach((group) => {
    // find lowest y position
    const min = groupedNodes[group].reduce((prev, curr) =>
      prev.position.y < curr.position.y ? prev : curr
    );
    groupedNodes[group].forEach((node) => {
      node.position.y = min.position.y;
    });
  });

  // cluster separation
  // node objects are passed by reference
  const nodesObject = nodes.reduce(
    // correct use of comma operator
    // eslint-disable-next-line no-sequences
    (obj, item) => ((obj[item.id] = item), obj),
    {}
  );
  const shift = (id, dx) => {
    nodesObject[id].position.x += dx;
    // recursion
    g.successors(id).forEach((child) => {
      shift(child, dx);
    });
  };
  const root = _.groupBy(nodes, ({ type }) => type).profile[0].id;
  const rootChildren = g.successors(root);
  const shiftAmount = 80;

  // shift root
  const sumChildrenX = rootChildren.reduce(
    (total, current) => total + nodesObject[current].position.x,
    0
  );
  nodesObject[root].position.x = sumChildrenX / rootChildren.length;

  // shift root children
  let dx = 0;
  rootChildren.forEach((rootChild) => {
    shift(rootChild, dx);
    dx += shiftAmount;
  });

  return { layoutedNodes: nodes, layoutedEdges: edges };
};
